/* Amaxa — Custom checkout. Пошта: Нова Пошта довідник + POST замовлення на бекенд.
   Конфіг читається з data-* атрибутів кореня .amxh; дані кошика — з JSON-тега [data-amxh-cart]. */
(function(){
  function init(root){
    if(!root || root.dataset.amxhInit) return;
    root.dataset.amxhInit = '1';
    if(window.lucide) lucide.createIcons();

    var form = root.querySelector('#amxh-form');
    if(!form) return;

    /* Телефон: префікс "+38 " незмінний, далі лише цифри, перша — 0 (укр. формат) */
    var phoneInput = form.querySelector('[data-phone-ua]');
    if(phoneInput){
      var PREFIX = '+38 ';
      function fmtPhone(){
        var digits = phoneInput.value.replace(/\D/g, '');       // усі цифри
        if(digits.indexOf('38') === 0) digits = digits.slice(2); // прибрати код країни
        digits = digits.replace(/^0+/, '0');                     // не більше одного провідного 0
        if(digits && digits[0] !== '0') digits = '0' + digits;   // форсуємо перший 0
        digits = digits.slice(0, 10);                            // 0XXXXXXXXX
        phoneInput.value = PREFIX + digits;
      }
      phoneInput.addEventListener('focus', function(){ if(!phoneInput.value.trim()) phoneInput.value = PREFIX; });
      phoneInput.addEventListener('input', fmtPhone);
      phoneInput.addEventListener('keydown', function(e){
        // не даємо стерти префікс
        if((e.key==='Backspace'||e.key==='Delete') && phoneInput.selectionStart <= PREFIX.length && phoneInput.selectionStart===phoneInput.selectionEnd){ e.preventDefault(); }
      });
    }

    var cartEl = root.querySelector('[data-amxh-cart]');
    var cartData = {};
    try { cartData = JSON.parse(cartEl ? cartEl.textContent : '{}'); } catch(e){ cartData = {}; }

    /* GA4 / GTM — begin_checkout */
    try {
      if(cartData.items && cartData.items.length){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event:'begin_checkout', ecommerce:{ currency:(cartData.currency||'UAH'), value:(cartData.total_price||0)/100, items:cartData.items.map(function(it){ return { item_name:it.product_title||it.title, item_variant:it.variant_title||'', quantity:it.quantity||1, price:((it.final_price||0)/100) }; }) } });
      }
    } catch(e){}

    var cfg = {
      endpoint: root.dataset.endpoint || '',
      npKey: root.dataset.npKey || '',
      npProxy: root.dataset.npProxy === 'true',
      clearUrl: root.dataset.cartClear,
      currency: root.dataset.currency || 'UAH'
    };

    /* ---------- Nova Poshta directory ---------- */
    function npRequest(modelName, calledMethod, props){
      if(cfg.npProxy && cfg.endpoint){
        return fetch(cfg.endpoint, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ action:'nova_poshta', modelName:modelName, calledMethod:calledMethod, methodProperties:props })
        }).then(function(r){return r.json();});
      }
      if(!cfg.npKey) return Promise.resolve({success:false, data:[]});
      return fetch('https://api.novaposhta.ua/v2.0/json/', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ apiKey: cfg.npKey, modelName:modelName, calledMethod:calledMethod, methodProperties:props })
      }).then(function(r){return r.json();});
    }

    var state = { cityRef:'', deliveryMethod:'warehouse' };

    function debounce(fn, ms){ var t; return function(){ var a=arguments, c=this; clearTimeout(t); t=setTimeout(function(){fn.apply(c,a);}, ms); }; }

    function bindAutocomplete(inputSel, acSel, fetcher, onPick){
      var input = form.querySelector(inputSel);
      var ac = form.querySelector(acSel);
      if(!input || !ac) return;
      function close(){ ac.classList.remove('open'); ac.innerHTML=''; }
      function render(items){
        if(!items || !items.length){
          if(!cfg.npKey && !cfg.npProxy){ ac.innerHTML='<div class="muted">Довідник Нової Пошти не налаштований</div>'; ac.classList.add('open'); return; }
          ac.innerHTML='<div class="muted">Нічого не знайдено</div>'; ac.classList.add('open'); return;
        }
        ac.innerHTML='';
        items.forEach(function(it){
          var d=document.createElement('div'); d.textContent=it.label;
          d.addEventListener('mousedown', function(e){ e.preventDefault(); input.value=it.label; onPick(it); close(); });
          ac.appendChild(d);
        });
        ac.classList.add('open');
      }
      var run = debounce(function(){
        var q=input.value.trim();
        if(q.length<1){ close(); return; }
        fetcher(q).then(render).catch(function(){ close(); });
      }, 250);
      input.addEventListener('input', function(){
        var hid = input.parentNode.querySelector('input[type="hidden"]');
        if(hid) hid.value='';
        run();
      });
      input.addEventListener('blur', function(){ setTimeout(close, 150); });
    }

    // City (settlements)
    bindAutocomplete('input[data-np="city"]', '[data-ac="city"]', function(q){
      return npRequest('Address','searchSettlements',{CityName:q, Limit:'15'}).then(function(res){
        var arr = (res && res.data && res.data[0] && res.data[0].Addresses) || [];
        return arr.map(function(a){ return { label:a.Present, ref:a.DeliveryCity || a.Ref }; });
      });
    }, function(pick){
      state.cityRef = pick.ref;
      form.querySelector('input[name="city_ref"]').value = pick.ref;
      var w=form.querySelector('input[name="warehouse"]'); if(w) w.value='';
      var wr=form.querySelector('input[name="warehouse_ref"]'); if(wr) wr.value='';
    });

    // Warehouse / Poshtomat — спільне поле, довідник залежить від обраного способу доставки
    bindAutocomplete('input[data-np="warehouse"]', '[data-ac="warehouse"]', function(q){
      if(!state.cityRef) return Promise.resolve([]);
      var wantPoshtomat = state.deliveryMethod === 'poshtomat';
      return npRequest('Address','getWarehouses',{CityRef:state.cityRef, FindByString:q, Limit:'50'}).then(function(res){
        var arr = (res && res.data) || [];
        return arr.filter(function(w){
          var isPoshtomat = w.CategoryOfWarehouse === 'Postomat' || /поштомат/i.test(w.Description || '');
          return wantPoshtomat ? isPoshtomat : !isPoshtomat;
        }).map(function(w){ return { label:w.Description, ref:w.Ref }; });
      });
    }, function(pick){
      form.querySelector('input[name="warehouse_ref"]').value = pick.ref;
    });

    /* ---------- Delivery method toggle ---------- */
    var whBlock = form.querySelector('[data-block="warehouse"]');
    var courierBlock = form.querySelector('[data-block="courier"]');
    var whInput = form.querySelector('input[data-np="warehouse"]');
    var whHidden = form.querySelector('input[name="warehouse_ref"]');
    var whLabel = form.querySelector('[data-wh-label]');
    var whErr = form.querySelector('[data-wh-err]');
    var WH_TEXT = {
      warehouse: { label:'Відділення Нової Пошти', placeholder:'Наприклад: Відділення №12, вул. Хрещатик 1', err:'Оберіть відділення зі списку' },
      poshtomat: { label:'Поштомат Нової Пошти', placeholder:'Наприклад: Поштомат №12345, вул. Хрещатик 1', err:'Оберіть поштомат зі списку' }
    };
    form.querySelectorAll('[data-group="delivery"] .amxh-opt').forEach(function(opt){
      opt.addEventListener('click', function(){
        form.querySelectorAll('[data-group="delivery"] .amxh-opt').forEach(function(o){o.classList.remove('sel');});
        opt.classList.add('sel');
        var m = opt.dataset.method;
        var prev = state.deliveryMethod;
        state.deliveryMethod = m;
        var isPoint = (m==='warehouse' || m==='poshtomat');
        if(whBlock) whBlock.style.display = isPoint ? 'block' : 'none';
        if(courierBlock) courierBlock.style.display = (m==='courier') ? 'block' : 'none';
        if(isPoint && prev !== m){
          // інший довідник (відділення/поштомат) — попередній вибір більше не валідний
          if(whInput) whInput.value='';
          if(whHidden) whHidden.value='';
          var t = WH_TEXT[m] || WH_TEXT.warehouse;
          if(whLabel) whLabel.textContent = t.label;
          if(whInput) whInput.placeholder = t.placeholder;
          if(whErr) whErr.textContent = t.err;
        }
      });
    });

    /* ---------- Payment toggle (cosmetic) ---------- */
    form.querySelectorAll('[data-group="payment"] .amxh-opt').forEach(function(opt){
      opt.addEventListener('click', function(){
        form.querySelectorAll('[data-group="payment"] .amxh-opt').forEach(function(o){o.classList.remove('sel');});
        opt.classList.add('sel');
      });
    });

    /* ---------- Promo (certificate) ---------- */
    var certInput = form.querySelector('input[name="certificate"]');
    if(certInput && !certInput.value.trim()){
      try {
        var savedPromo = sessionStorage.getItem('amx_promo_code');
        if(savedPromo) certInput.value = savedPromo;
      } catch(e){}
    }
    var promoBtn = form.querySelector('[data-promo]');
    if(promoBtn){
      promoBtn.addEventListener('click', function(){
        var code = (form.querySelector('input[name="certificate"]').value || '').trim();
        if(!code){ showMsg('Введіть номер сертифіката.', 'err'); return; }
        promoBtn.disabled = true;
        showMsg('Перевіряємо код…', 'ok');
        fetch('/cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ discount: code })
        }).then(function(r){ return r.json(); }).then(function(cartRes){
          var applied = cartRes && cartRes.cart_level_discount_applications && cartRes.cart_level_discount_applications.length > 0;
          if(applied){
            try { sessionStorage.setItem('amx_promo_code', code); } catch(e){}
            window.location.reload();
            return;
          }
          fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({discount:''})}).catch(function(){});
          try { sessionStorage.removeItem('amx_promo_code'); } catch(e){}
          showMsg('Промокод недійсний або вже не активний.', 'err');
          promoBtn.disabled = false;
        }).catch(function(){
          showMsg('Не вдалося перевірити код. Спробуйте ще раз.', 'err');
          promoBtn.disabled = false;
        });
      });
    }

    /* ---------- Validation ---------- */
    function setInvalid(fld, bad){ fld.classList[bad?'add':'remove']('invalid'); }
    function validate(){
      var ok = true;
      form.querySelectorAll('.amxh-fld[data-required]').forEach(function(fld){
        var inp = fld.querySelector('input,select');
        var v = (inp.value||'').trim();
        var bad = !v;
        if(!bad && fld.dataset.type==='phone'){ bad = v.replace(/\D/g,'').length < 10; }
        setInvalid(fld, bad); if(bad) ok=false;
      });
      var emailFld = form.querySelector('.amxh-fld[data-type="email"]');
      if(emailFld){ var e=emailFld.querySelector('input').value.trim(); var bad = e && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e); setInvalid(emailFld, bad); if(bad) ok=false; }
      var method = form.querySelector('input[name="delivery_method"]:checked').value;
      var whFld = form.querySelector('[data-block="warehouse"] .amxh-fld');
      if(method==='warehouse' || method==='poshtomat'){
        var wv = form.querySelector('input[name="warehouse"]').value.trim();
        var bad = !wv; setInvalid(whFld, bad); if(bad) ok=false;
      } else { setInvalid(whFld, false); }
      return ok;
    }

    function showMsg(text, type){
      var el = root.querySelector('#amxh-msg');
      el.className = 'amxh-formmsg ' + (type||'err');
      el.textContent = text;
    }

    /* ---------- Order payload ---------- */
    function buildPayload(){
      var g = function(n){ var el=form.querySelector('[name="'+n+'"]'); return el?el.value.trim():''; };
      return {
        action: 'create_order',
        currency: cfg.currency,
        contact: {
          first_name: g('first_name'), last_name: g('last_name'),
          phone: g('phone'), email: g('email'),
          no_callback: !!form.querySelector('[name="no_callback"]').checked
        },
        delivery: {
          carrier: 'nova_poshta',
          method: form.querySelector('input[name="delivery_method"]:checked').value,
          area: g('area'), city: g('city'), city_ref: g('city_ref'),
          warehouse: g('warehouse'), warehouse_ref: g('warehouse_ref'),
          street: g('street'), house: g('house'), apartment: g('apartment')
        },
        payment_method: form.querySelector('input[name="payment_method"]:checked').value,
        certificate: g('certificate'),
        comment: g('comment'),
        cart: cartData
      };
    }

    /* ---------- Submit ---------- */
    var submitBtn = form.querySelector('.amxh-submit');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(!validate()){ showMsg('Будь ласка, заповніть обов’язкові поля.', 'err'); return; }
      var payload = buildPayload();

      if(!cfg.endpoint){
        showMsg('Бекенд оформлення ще не налаштований (додайте URL у налаштуваннях секції). Дані замовлення зібрано коректно.', 'err');
        console.log('[amaxa checkout] payload →', payload);
        return;
      }

      submitBtn.disabled = true;
      var orig = submitBtn.innerHTML; submitBtn.textContent = 'Обробка…';

      fetch(cfg.endpoint, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify(payload)
      })
      .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if(!res.ok || (res.j && res.j.error)){
          throw new Error((res.j && res.j.error) || 'Помилка сервера');
        }
        if(payload.payment_method==='online' && res.j){
          if(res.j.payUrl){ window.location.href = res.j.payUrl; return; }
          if(res.j.wayforpay){ submitWayForPay(res.j.wayforpay); return; }
        }
        // Зберігаємо деталі для сторінки «Дякуємо» і переходимо на неї.
        try {
          var saved = JSON.parse(JSON.stringify(payload));
          saved.order_number = res.j && res.j.order_number;
          sessionStorage.setItem('amx_last_order', JSON.stringify(saved));
          sessionStorage.removeItem('amx_promo_code');
        } catch(e){}
        Promise.all([
          fetch(cfg.clearUrl, {method:'POST'}).catch(function(){}),
          fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({discount:''})}).catch(function(){})
        ]).finally(function(){
          window.location.href = '/pages/thank-you';
        });
      })
      .catch(function(err){
        submitBtn.disabled = false; submitBtn.innerHTML = orig;
        if(window.lucide) lucide.createIcons();
        showMsg('Не вдалося оформити замовлення: ' + err.message + '. Спробуйте ще раз або зателефонуйте нам.', 'err');
      });
    });

    function submitWayForPay(data){
      var f = document.createElement('form');
      f.method = 'POST';
      f.action = data._action || 'https://secure.wayforpay.com/pay';
      delete data._action;
      Object.keys(data).forEach(function(k){
        var v = data[k];
        var push = function(val){ var i=document.createElement('input'); i.type='hidden'; i.name=k; i.value=val; f.appendChild(i); };
        if(Array.isArray(v)){ v.forEach(function(x){ var i=document.createElement('input'); i.type='hidden'; i.name=k+'[]'; i.value=x; f.appendChild(i); }); }
        else push(v);
      });
      document.body.appendChild(f); f.submit();
    }

    function showDone(orderNumber){
      var done = root.querySelector('#amxh-done');
      if(orderNumber){ root.querySelector('#amxh-done-text').textContent = 'Номер вашого замовлення: №'+orderNumber+'. Ми зв’яжемося з вами найближчим часом для підтвердження.'; }
      form.style.display='none';
      done.style.display='block';
      if(window.lucide) lucide.createIcons();
      window.scrollTo({top:0, behavior:'smooth'});
    }
  }

  function boot(){ document.querySelectorAll('.amxh').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
